import { render, staticRenderFns } from "./recruit.vue?vue&type=template&id=6df6ed0f&scoped=true&"
import script from "./recruit.vue?vue&type=script&lang=js&"
export * from "./recruit.vue?vue&type=script&lang=js&"
import style0 from "./recruit.vue?vue&type=style&index=0&lang=less&"
import style1 from "./recruit.vue?vue&type=style&index=1&id=6df6ed0f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6ed0f",
  null
  
)

export default component.exports